import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { RelateToPermitData } from './relate-to-permit-card.model';
import { WorkflowApplicationsJanusService } from '../workflow-applications-janus.service';
import { DataService, WorkflowContextService } from 'src/app/services';
import { finalize } from 'rxjs';
import { ItemSearchOptionField } from 'src/app/components/filter-list/models/filterClasses';
import { ActivatedRoute } from '@angular/router';
import { CommonConfirmationModalData } from 'src/app/components/common/common-confirmation-modal/common-confirmation-modal.component.model';
import { UnlinkWorkflowApplicationRequest } from 'src/app/models/linked-application';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'wm-relate-to-permit-card',
  standalone: false,
  templateUrl: './relate-to-permit-card.component.html',
  styleUrl: './relate-to-permit-card.component.scss'
})
export class RelateToPermitCard implements OnInit {
  relateToPermitDetails: RelateToPermitData = {
    rows: [],
    headers: [],
    selectedIds: [],
    loader: false,
    dataLoader: false,
    errorMsg: '',
    pageNumber: 1,
    totalNoOfPages: 0,
    totalNoOfRows: 20,
    relatedApplications:[],
    fetchErrorRelatedApplications:false,
    fetchingRelatedApplications:false,
    submitting:false,
    idToUnlink:null
  };
  relateToPermitSubmitModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Update Application Description',
    modalSubDescp: 'Are you sure you want to recalculate the Application Description?',
    yesNoBtn: false,
    okBtn: true,
    closeBtn: false,
    inTime: 300,
    outTime: 200,
    status: 'default'
  };
  removeRelatedPermitConfirmationModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Remove Related Permit',
    modalSubDescp: 'Are you sure you want to remove the related permit',
    yesNoBtn: true,
    okBtn: false,
    closeBtn: false,
    inTime: 300,
    outTime: 200,
    status: 'default'
  };
  constructor(
    private workflowApplicationsJanusSvc: WorkflowApplicationsJanusService,
    private dataSvc: DataService,
    public context: WorkflowContextService,
    public route : ActivatedRoute,
    private toastr: ToastrService,
  ) {}
  @ViewChild('applicationNoHeaderTemplate', { static: true })
  applicationNoHeaderTemplate!: TemplateRef<any>;

  // @ViewChild('permitNoHeaderTemplate', { static: true })
  // permitNoHeaderTemplate!: TemplateRef<any>;

  @ViewChild('siteAddressHeaderTemplate', { static: true })
  siteAddressHeaderTemplate!: TemplateRef<any>;

  @ViewChild('workDescpHeaderTemplate', { static: true })
  workDescpHeaderTemplate!: TemplateRef<any>;

  applicationNoSearchQuery: string = '';
  applicationNoSearchFieldConfig = {
    label: 'Search',
    type: 'text',
    variant: 'outline',
    startIcon: {
      matIconName: 'search'
    }
  };
  handleApplicationNoSearchChange(value: string): void {
    this.applicationNoSearchQuery = value;
    this.relateToPermitDetails.pageNumber = 1;
    this.fetchPermitsToBeRelated();
  }
  // permitNoSearchQuery: string = '';
  // permitNoSearchFieldConfig = {
  //   label: 'Search',
  //   type: 'text',
  //   variant: 'outline',
  //   startIcon: {
  //     matIconName: 'search'
  //   }
  // };
  // handlePermitNoSearchChange(value: string): void {
  //   this.permitNoSearchQuery = value;
  //   this.relateToPermitDetails.pageNumber = 1;
  //   this.fetchPermitsToBeRelated();
  // }
  siteAddressSearchQuery: string = '';
  siteAddressSearchFieldConfig = {
    label: 'Search',
    type: 'text',
    variant: 'outline',
    startIcon: {
      matIconName: 'search'
    }
  };
  handleSiteAddressSearchChange(value: string): void {
    this.siteAddressSearchQuery = value;
    this.relateToPermitDetails.pageNumber = 1;
    this.fetchPermitsToBeRelated();
  }
  workDescriptionSearchQuery: string = '';
  workDescriptionSearchFieldConfig = {
    label: 'Search',
    type: 'text',
    variant: 'outline',
    startIcon: {
      matIconName: 'search'
    }
  };
  handleWorkDescriptionSearchChange(value: string): void {
    this.workDescriptionSearchQuery = value;
    this.relateToPermitDetails.pageNumber = 1;
    this.fetchPermitsToBeRelated();
  }

  ngOnInit(): void {
    this.workflowApplicationsJanusSvc.data$.subscribe((data)=>{
      this.relateToPermitDetails.relatedApplications = data.linkedApplications
    })
    this.fetchPermitsToBeRelated();
  }

  fetchRelatedPermits = ()=>{
    this.relateToPermitDetails.fetchErrorRelatedApplications=false;
    this.relateToPermitDetails.fetchingRelatedApplications = true;
    const currentId = this.route.snapshot.queryParamMap.get('id');
    this.dataSvc.getLinkedApplications(currentId)
    .pipe(
        finalize(() => {
          this.relateToPermitDetails.fetchingRelatedApplications = false;
          this.fetchPermitsToBeRelated();
          this.workflowApplicationsJanusSvc.setData({
            ...this.workflowApplicationsJanusSvc.getData(),
            linkedApplications:this.relateToPermitDetails.relatedApplications
          });
        })
      )
    .subscribe({
      next:(res)=>{
        if(res && res.length>0){
          this.relateToPermitDetails.relatedApplications = res;
        }else{
          this.relateToPermitDetails.relatedApplications = [];
        }
      },
      error:(err)=>{
        this.relateToPermitDetails.relatedApplications = [];
        this.relateToPermitDetails.fetchErrorRelatedApplications=true;
      }
    })
  }
  fetchPermitsToBeRelated = () => {
    if (this.relateToPermitDetails.headers.length === 0) {
      this.relateToPermitDetails.loader = true;
    } else {
      this.relateToPermitDetails.dataLoader = true;
    }
    this.relateToPermitDetails.errorMsg = '';
    let filterInputs: ItemSearchOptionField[] = [
      {
        title: 'clientId',
        options: [
          {
            title: 'clientId',
            searchOptionMethod: '',
            searchText: this.context.client.id,
            filterText: '',
            selected: true,
            strOperator: ''
          }
        ]
      },
      {
        title: 'departmentId',
        options: [
          {
            title: 'departmentId',
            searchOptionMethod: '',
            searchText: this.context.staffDepartmentId,
            filterText: '',
            selected: true,
            strOperator: ''
          }
        ]
      }
    ];
    if (this.applicationNoSearchQuery !== '') {
      filterInputs.push({
        title: 'applicationNumber',
        options: [
          {
            title: 'applicationNumber',
            searchOptionMethod: 'simpleSearch',
            selected: true,
            filterText: this.applicationNoSearchQuery || '',
            strOperator: '',
            searchText: ''
          }
        ]
      });
    }
    // if (this.permitNoSearchQuery !== '') {
    //   filterInputs.push({
    //     title: 'applicationNumber',
    //     options: [
    //       {
    //         title: 'applicationNumber',
    //         searchOptionMethod: 'simpleSearch',
    //         selected: true,
    //         filterText: this.permitNoSearchQuery || '',
    //         strOperator: '',
    //         searchText: ''
    //       }
    //     ]
    //   });
    // }
    if (this.siteAddressSearchQuery !== '') {
      filterInputs.push({
        title: 'parcelAddress',
        options: [
          {
            title: 'parcelAddress',
            searchOptionMethod: 'simpleSearch',
            selected: true,
            filterText: this.siteAddressSearchQuery,
            strOperator: '',
            searchText: ''
          }
        ]
      });
    }
    if (this.workDescriptionSearchQuery !== '') {
      filterInputs.push({
        title: 'description',
        options: [
          {
            title: 'description',
            searchOptionMethod: 'simpleSearch',
            selected: true,
            filterText: this.workDescriptionSearchQuery,
            strOperator: '',
            searchText: ''
          }
        ]
      });
    }
    this.dataSvc
      .getAllWorkflowApplications(
        null,
        null,
        true,
        filterInputs,
        this.relateToPermitDetails.pageNumber,
        this.relateToPermitDetails.totalNoOfRows,
        null,
        false
      )
      .pipe(
        finalize(() => {
          this.relateToPermitDetails.loader = false;
          this.relateToPermitDetails.dataLoader = false;
        })
      )
      .subscribe({
        next: response => {
          this.relateToPermitDetails.headers = [
            {
              key: 'selected',
              headerType: 'checkbox',
              cellType: 'checkbox',
              sortable: false,
              hideMenu: true,
              headerAlignTop:true
            },
            {
              key: 'Application #',
              headerType: 'template',
              cellType: 'text',
              sortable: false,
              hideMenu: true,
              headerTemplate: this.applicationNoHeaderTemplate
            },
            // {
            //   key: 'Permit #',
            //   headerType: 'template',
            //   cellType: 'text',
            //   sortable: false,
            //   hideMenu: true,
            //   headerTemplate: this.permitNoHeaderTemplate
            // },
            {
              key: 'Site Address',
              headerType: 'template',
              cellType: 'text',
              sortable: false,
              hideMenu: true,
              headerTemplate: this.siteAddressHeaderTemplate
            },
            {
              key: 'Work Descp',
              headerType: 'template',
              cellType: 'text',
              sortable: false,
              hideMenu: true,
              headerTemplate: this.workDescpHeaderTemplate
            }
          ];
          const relatedApplicationIds =
  this.relateToPermitDetails.relatedApplications.map(
    relatedApp => relatedApp.workflowApplicationId
  );
          this.relateToPermitDetails.rows = response.workflowApplications
          .filter(app => !relatedApplicationIds.includes(app.id))
          .map(
            app => ({
              id: app.id,
              selected: false,
              'Application #': app.applicationNumber || '--',
              // 'Permit #': app.applicationNumber || '--',
              'Site Address': app.parcelAddress || '--', // fallback handled
              'Work Descp': app.description || '--'
            })
          );
          this.relateToPermitDetails.totalNoOfPages = response.pageCount;
        },
        error: err => {
          this.relateToPermitDetails.errorMsg =
            'error fetching list of applications';
        }
      });
  };

  // code added by Krutika
  submitRelatedPermits = () => {
    this.relateToPermitDetails.submitting=true;
  const payload = {
    applicationId: this.context.applicationId,
    relatedPermitIds: this.relateToPermitDetails.selectedIds
  };
 this.dataSvc
  .bulkRelatePermit(payload)
  .pipe(finalize(()=>{
    this.relateToPermitDetails.submitting = false;
  }))
  .subscribe({
    next: response => {
      if(response?.success === true){
this.relateToPermitSubmitModalData = {
          ...this.relateToPermitSubmitModalData,
          open: true,
          modalDescp:'Success',
          modalSubDescp:'The selected permits have been related successfully'
        }
      }else{
        // show error modal
        this.relateToPermitSubmitModalData = {
          ...this.relateToPermitSubmitModalData,
          open: true,
          modalDescp:'Failed',
          modalSubDescp:'Unable to relate the selected permits. Please try again.'
        }
      }

    },
    error: err => {
      this.relateToPermitSubmitModalData = {
          ...this.relateToPermitSubmitModalData,
          open: true,
          modalDescp:'Error',
          modalSubDescp:'An unexpected error occurred while relating permits. Please try again later.'
        }
    }
  });
};
  // End code by Krutika
  handleRelateToPermitModalOk = ()=>{
    this.fetchRelatedPermits();
    this.relateToPermitSubmitModalData = {
          ...this.relateToPermitSubmitModalData,
          open: false
        };
  };

  onPageChange(page: number): void {
    this.relateToPermitDetails.pageNumber = page + 1;
    this.fetchPermitsToBeRelated();
  }
  closeCard = () => {
    this.workflowApplicationsJanusSvc.setData({
      ...this.workflowApplicationsJanusSvc.getData(),
      showRelateToPermitView: false
    });
  };
  removeRelatedPermit(removeId:string) {
    this.relateToPermitDetails.idToUnlink = removeId;
    this.removeRelatedPermitConfirmationModalData = {
      ...this.removeRelatedPermitConfirmationModalData,
      open:true
    }
  }
  handleRemoveRelatedPermitModalAccepted=()=>{
    const currentId = this.route.snapshot.queryParamMap.get('id');
    const req : UnlinkWorkflowApplicationRequest = {
      workflowApplicationId:currentId,
      workflowApplicationIdToUnlink:this.relateToPermitDetails.idToUnlink
    }
    this.dataSvc.unlinkWorkflowApplication(req).
    pipe(finalize(()=>{
      this.relateToPermitDetails.idToUnlink = null;
      this.removeRelatedPermitConfirmationModalData = {
      ...this.removeRelatedPermitConfirmationModalData,
      open:false
    }
    }))
    .subscribe({
      next:(res)=>{
        if(res && res === true){
 this.toastr.success('The related permit has been removed successfully.');
 this.fetchRelatedPermits();
        }else{
 this.toastr.error( 'Unable to remove the related permit. Please try again.');
        }
      },
      error:(err)=>{
        this.toastr.error('An unexpected error occurred while removing the related permit.');
      }
    })
  }
  handleRemoveRelatedPermitModalRejected=()=>{
    this.relateToPermitDetails.idToUnlink = null;
    this.removeRelatedPermitConfirmationModalData = {
      ...this.removeRelatedPermitConfirmationModalData,
      open:false
    }
  }
  onSpecificRowCheckboxClick = row => {
    if (
      row.selected === true &&
      !this.relateToPermitDetails.selectedIds.includes(row.id)
    ) {
      this.relateToPermitDetails.selectedIds.push(row.id);
    } else if (
      row.selected === false &&
      this.relateToPermitDetails.selectedIds.includes(row.id)
    ) {
      this.relateToPermitDetails.selectedIds = this.relateToPermitDetails.selectedIds.filter(
        id => row.id !== id
      );
    }
  };
  onHeaderCheckboxClick = (rows: any[]) => {
    rows.forEach(row => {
      if (
        row.selected === true &&
        !this.relateToPermitDetails.selectedIds.includes(row.id)
      ) {
        this.relateToPermitDetails.selectedIds.push(row.id);
      } else if (
        row.selected === false &&
        this.relateToPermitDetails.selectedIds.includes(row.id)
      ) {
        this.relateToPermitDetails.selectedIds = this.relateToPermitDetails.selectedIds.filter(
          id => id !== row.id
        );
      }
    });
  };
}
